import AsyncStorage from '@react-native-async-storage/async-storage'

const KEY = 'referralSlug'

export const saveReferralSlug = (slug: string) =>
  AsyncStorage.setItem(KEY, slug).catch(err => console.error('🔴 Error setting referral slug to storage.', err))

export const getReferralSlug = () =>
  AsyncStorage.getItem(KEY).catch(err => {
    console.error('🔴 Error getting referral slug from storage.', err)
    return null
  })

export const removeReferralSlug = () =>
  AsyncStorage.removeItem(KEY).catch(err => console.error('🔴 Error removing referral slug from storage.', err))
